import type { FunctionComponent } from "react";
import type { RecordJobData } from "@smartsuite/automation-engine-api";
import { ActivityDetailsTriggerGroup } from "../ActivityDetailsTriggerGroup/ActivityDetailsTriggerGroup";
import { ActivityDetailsItem } from "../ActivityDetailsItem/ActivityDetailsItem";
import { RECORD_ID } from "../../../../../utils/constants";
import {
  addEmptyValueIfNeeded,
  findRecordValue,
} from "../../../ActivityGrid/ActivityGrid.helpers";
import { valueDataToString } from "@smartsuite/automation-conditions";

export const DocsAutomatorGroupWrapper: FunctionComponent<{
  index: number;
  recordJob?: RecordJobData;
  recordJodId?: string;
  onDetailsClickWithFetch?: (recordJodId: string) => Promise<void>;
  onDetailsClick?: () => void;
}> = ({
  index,
  recordJob,
  onDetailsClickWithFetch,
  onDetailsClick,
  recordJodId,
}) => {
  const record =
    recordJob?.outputData?.recordList?.recordList !== undefined
      ? recordJob.outputData.recordList.recordList.records[0]
      : recordJob?.record;

  const output = record?.outputs.find(
    (output) => output.outputId === RECORD_ID,
  );

  const tableIdInput = recordJob?.inputs?.find(
    (input) => input.inputId === "application-id",
  );

  const solutionIdInput = recordJob?.inputs?.find(
    (input) => input.inputId === "solution-id",
  );

  const docsAutomatorAutomationIdInput = recordJob?.inputs?.find(
    (input) => input.inputId === "docsautomator_automation",
  );

  const pdfDocumentInput = recordJob?.inputs?.find(
    (input) => input.inputId === "pdf_title",
  );

  const exportedPdfTitleOutput = recordJob?.outputData?.outputs?.find(
    (output) => output.outputId === "exported-pdf-title",
  );

  const exportedPdfUrlOutput = recordJob?.outputData?.outputs?.find(
    (output) => output.outputId === "exported-pdf-url",
  );

  let tableId = recordJob === undefined ? "" : "<no value>";
  if (tableIdInput !== undefined) {
    tableId = valueDataToString(tableIdInput.value);
  }

  let solutionId = "<no value>";
  if (solutionIdInput !== undefined) {
    solutionId = valueDataToString(solutionIdInput.value);
  }

  let docsAutomatorAutomationId = "<no value>";
  if (docsAutomatorAutomationIdInput !== undefined) {
    docsAutomatorAutomationId = valueDataToString(
      docsAutomatorAutomationIdInput.value,
    );
  }

  let pdfDocument = "<no value>";
  if (pdfDocumentInput !== undefined) {
    pdfDocument = valueDataToString(pdfDocumentInput.value);
  }

  let exportedPdfTitle = "<no value>";
  if (exportedPdfTitleOutput !== undefined) {
    exportedPdfTitle = valueDataToString(exportedPdfTitleOutput.value);
  }

  let exportedPdfUrl = "<no value>";
  if (exportedPdfUrlOutput !== undefined) {
    exportedPdfUrl = valueDataToString(exportedPdfUrlOutput.value);
  }

  return (
    <ActivityDetailsTriggerGroup
      title={`Record ${index + 1}`}
      onClick={() => {
        if (
          onDetailsClickWithFetch !== undefined &&
          recordJodId !== undefined
        ) {
          void onDetailsClickWithFetch(recordJodId);
        }
        if (onDetailsClick !== undefined) {
          onDetailsClick();
        }
      }}
    >
      <ActivityDetailsItem label="Application ID">
        {tableId}
      </ActivityDetailsItem>
      <ActivityDetailsItem label="Solution ID">
        {solutionId}
      </ActivityDetailsItem>
      <ActivityDetailsItem label="DocsAutomator Automation ID">
        {docsAutomatorAutomationId}
      </ActivityDetailsItem>
      <ActivityDetailsItem label="Pdf Document">
        {exportedPdfUrl ? (
          <a href={exportedPdfUrl} target="_blank" rel="noreferrer">
            {exportedPdfTitle}
          </a>
        ) : (
          <span>{exportedPdfTitle}</span>
        )}
      </ActivityDetailsItem>
      {output !== undefined && (
        <ActivityDetailsItem label={output.outputLabel}>
          {addEmptyValueIfNeeded(findRecordValue(output.outputId, record))}
        </ActivityDetailsItem>
      )}
    </ActivityDetailsTriggerGroup>
  );
};
